<template>
  <div v-loading="loading" class="day-order-info">
    <div class="title">
      订单统计
      <div class="timespan-selector">
        <el-date-picker
          type="daterange"
          v-model="timeSpan"
          @change="loadData"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="content">
      <table>
        <tr>
          <td>区域<sort-caret col="area" @change="doSort" /></td>
          <td>订单量<sort-caret col="orderCount" @change="doSort" /></td>
          <td>客户量<sort-caret col="buyerCount" @change="doSort" /></td>
          <td>销售额<sort-caret col="sellAmount" @change="doSort" /></td>
          <td>退款额<sort-caret col="returnAmount" @change="doSort" /></td>
          <td>净销售额<sort-caret col="netAmount" @change="doSort" /></td>
        </tr>
        <template v-if="context && context.length">
          <tr v-for="row in context" :key="row.area">
            <td>{{ row.area }}</td>
            <td>{{ row.orderCount }}</td>
            <td>{{ row.buyerCount }}</td>
            <td>{{ +row.sellAmount.toFixed(2) | currencyFmt }}</td>
            <td>{{ +row.returnAmount.toFixed(2) | currencyFmt }}</td>
            <td>{{ +(row.sellAmount - row.returnAmount).toFixed(2) | currencyFmt }}</td>
          </tr>
          <tr v-if="context.length > 1">
            <td>合计</td>
            <td>{{ context.reduce((p, c) => p + c.orderCount, 0) }}</td>
            <td>{{ context.reduce((p, c) => p + c.buyerCount, 0) }}</td>
            <td>{{ +context.reduce((p, c) => p + c.sellAmount, 0).toFixed(2) | currencyFmt }}</td>
            <td>{{ +context.reduce((p, c) => p + c.returnAmount, 0).toFixed(2) | currencyFmt }}</td>
            <td>{{ +context.reduce((p, c) => p + c.sellAmount - c.returnAmount, 0).toFixed(2) | currencyFmt }}</td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td :colspan="6" class="no-data">暂无数据</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>
<script>
import { loadDayOrderInfo } from '../services'
import SortCaret from '@/components/SortCaret.vue'
import moment from 'moment'
export default {
  name: 'DayOrderInfo',
  components: { SortCaret },
  data () {
    const now = new Date()
    const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const nextDay = new Date(nowDate.getTime() + 86400000)
    return {
      loading: true,
      context: [],
      timeSpan: [nowDate, nextDay],
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick (picker) {
              picker.$emit('pick', [nowDate, nextDay])
            }
          },
          {
            text: '昨天',
            onClick (picker) {
              const start = new Date(nowDate.getTime() - 86400000)
              picker.$emit('pick', [start, nowDate])
            }
          },
          {
            text: '本月',
            onClick (picker) {
              const start = new Date(now.getFullYear(), now.getMonth(), 1)
              picker.$emit('pick', [start, nextDay])
            }
          },
          {
            text: '上月',
            onClick (picker) {
              const start = new Date(now.getFullYear(), now.getMonth() - 1, 1)
              const end = new Date(now.getFullYear(), now.getMonth(), 1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '今年',
            onClick (picker) {
              const start = new Date(now.getFullYear(), 0, 1)
              picker.$emit('pick', [start, nextDay])
            }
          }
        ]
      }
    }
  },
  methods: {
    doSort (sortConfig) {
      this.context.sort((a, b) => {
        if (sortConfig.col === 'area') {
          if (sortConfig.direct === 1) {
            return a.area.localeCompare(b.area)
          } else {
            return b.area.localeCompare(a.area)
          }
        }
        if (sortConfig.direct === 1) {
          return a[sortConfig.col] - b[sortConfig.col]
        } else {
          return b[sortConfig.col] - a[sortConfig.col]
        }
      })
    },
    loadData () {
      this.loading = true
      let startTime = (this.timeSpan || [])[0] || undefined
      let endTime = (this.timeSpan || [])[1] || undefined
      if (startTime) {
        startTime = moment(startTime).format('YYYY-MM-DD')
      }
      if (endTime) {
        endTime = moment(endTime).format('YYYY-MM-DD')
      }
      loadDayOrderInfo(this.area, startTime, endTime).then((resp) => {
        resp.forEach(item => { item.netAmount = item.sellAmount - item.returnAmount })
        this.context = resp
      }).finally(() => {
        this.loading = false
      })
    }
  },
  beforeMount () {
    this.loadData()
  },
  watch: {
    area () {
      this.loadData()
    }
  }
}
</script>
